import { constants } from 'lib_ui-services';
import lodash from 'lodash';
import navigationProperties from '@sstdev/lib_metadata-authoring/src/navigationProperties';
const { cloneDeep } = lodash;
const { isEqual } = lodash;

export default {
    verb: 'didUpdate',
    namespace: 'metadata',
    relation: 'page',
    description: 'Keep Navigation record in sync with page',
    //type: '',
    //priority:0,
    //useCaseIds:[]
    prerequisites: [
        {
            context: {
                verb: 'get',
                namespace: 'metadata',
                relation: 'navigation',
                type: 'find'
            },
            query: ({ data }) => {
                const {
                    'metadata:useCaseDetail': { _id }
                } = data.newRecord;
                return {
                    'metadata:useCaseDetail._id': _id,
                    'meta.deleted': { $exists: false }
                };
            }
        }
    ],
    //this is the actual logic:
    logic: didUpdate
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function didUpdate({
    data,
    prerequisiteResults: [
        {
            result: [originalNavigation]
        }
    ],
    dispatch
}) {
    if (data.authoringCommitted) return data;
    const topBlock = data.newRecord.blockly.blocks.blocks.find(b => constants.acceptableTopBlocks.includes(b.type));

    // Prerequisites return live cache records. Keep failed or pending edits out of the cache.
    const navigation = cloneDeep(originalNavigation);
    const navEntryRef = findRecursively(navigation.children, data.newRecord._id);
    const navEntryCopy = cloneDeep(navEntryRef);

    //only keep the basic props
    Object.keys(navEntryRef).forEach(key => {
        if (['_id', 'children'].includes(key)) return;
        //we have to delete the unwanted keys off, as we have a reference,
        //and we can't just spread the object and reassign a new object.
        delete navEntryRef[key];
    });
    Object.assign(navEntryRef, navigationProperties(topBlock));

    if (!isEqual(navEntryCopy, navEntryRef)) {
        // A heading has no page document: its navigation save must finish before
        // the outer page workflow can report success or propagate a save failure.
        await dispatch(
            { oldRecord: originalNavigation, newRecord: navigation },
            {
                verb: 'update',
                namespace: 'metadata',
                relation: 'navigation'
            },
            true
        );
        // Saving a navigation-only heading already committed its build and history.
        return { ...data, authoringCommitted: true };
    }
}

function findRecursively(children, _id) {
    if (!children || !children.length) return;
    for (const child of children) {
        if (child._id === _id) return child;
        const grandChild = findRecursively(child.children, _id);
        if (grandChild) return grandChild;
    }
}
